import { ApiFragment, RecordTypeStructure } from '@stylehaven/components';
import { ActionDisabledCondition, UserAction } from '../../entities/common/user-action.entity';

/* Export preview
 * Available when:
 *  * Is published or archived
 *  * Is not deleted
 *  * Is not a representation
 *  * Is not an intellectual object
 *
 * Disabled when:
 *  * Does not have preview
 */
export function GetExportPreviewUserAction(record: ApiFragment): UserAction {
    const isPublished: boolean = record.isPublished();
    const isArchived: boolean = record.isArchived();
    const isDeleted: boolean = record.isDeleted();
    const isIntellectual: boolean = record.isIntellectualObject();
    const isRepresentation: boolean = record.getRecordStructure() === RecordTypeStructure.Representation;

    const hasPreview: boolean = record.hasPreview();

    const availableConditions: boolean[] = [isPublished || isArchived, !isDeleted, !isRepresentation, !isIntellectual];
    const disableConditions: ActionDisabledCondition[] = [{ condition: !hasPreview, tooltip: 'general.no-preview' }];

    const exportAction: UserAction = new UserAction(availableConditions, disableConditions);
    return exportAction;
}
